module.exports = __webpack_public_path__ + "static/olivia-a33b44f5c0bceb97fc6da17ee966c7a2.jpg";